// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iYTpb2CW4DS3dE {
  display: flex;
  margin-bottom: var(--ds-space-050, 4px);
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px) var(--ds-space-075, 6px) var(--ds-space-150, 10px);
  border-radius: var(--ds-border-radius-100, 3px);
  font-weight: var(--ds-font-weight-medium, 500);
}
.nt7dAMKxIasOcz {
  margin-left: var(--ds-space-100, 8px);
  float: left;
  clear: both;
  transition: transform 85ms ease-in;
  background-color: rgba(0, 0, 0, 0.6);
  color: #c7d1db;
}
.nt7dAMKxIasOcz:hover,
.nt7dAMKxIasOcz:active {
  transform: translateX(5px);
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
}
.f2W9CDemJJk_se {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  color: var(--ds-text, #172b4d);
}
.f2W9CDemJJk_se:hover,
.f2W9CDemJJk_se:active {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.ces_LS4unmzSlQ {
  margin-right: var(--ds-space-100, 8px);
}
`, ""]);
// Exports
export var button = `iYTpb2CW4DS3dE`;
var _1 = `nt7dAMKxIasOcz`;
export { _1 as "button--legacy" };
var _2 = `f2W9CDemJJk_se`;
export { _2 as "button--hover" };
export var icon = `ces_LS4unmzSlQ`;
export default ___CSS_LOADER_EXPORT___;
